<template>
  <div>
    <h1>Game Add</h1>

    <div class="row">
      <div class="small-6 columns"><div>Name</div></div>
      <div class="small-6 columns">
        <input v-model="gameObj.name" type="text" />
      </div>
    </div>

    <div class="row">
      <div class="small-3 columns">Points</div>
      <div class="small-9 columns" style="z-index:10000;position:relative">
        <input id="" v-model="points" type="number" name="" />
      </div>
    </div>

    <div class="row" style="margin-top:20px">
      <div class="small-6 columns"><div>Time Allocated</div></div>
      <div class="small-6 columns">
        <input v-model="gameObj.time_allocated" type="text" />
      </div>
    </div>
    <div class="row" style="margin-bottom:20px">
      <div class="small-6 columns"><div>Is Time Bound</div></div>
      <div class="small-6 columns">
        <input v-model="gameObj.is_time_bound" type="checkbox" />
      </div>
    </div>

    <div class="row">
      <div class="small-3 columns">Tags</div>
      <div class="small-9 columns" style="z-index:10000;position:relative">
        <VueSelect
          v-model="selectedTags"
          :options="tagOptions"
          label="name"
          multiple
        />
      </div>
    </div>

    <div class="row">
      <div class="small-6 columns">
        <div>Script File</div>
        <div><sub>please upload a minified+ uglified js file</sub></div>
      </div>
      <div class="small-6 columns">
        <SingleFileUpload
          @codingFileUploadSuccess="catchFileUploadSuccess($event)"
        />
      </div>
    </div>

    <div class="row">
      <div class="small-12 columns"><h3>Game Config</h3></div>
      <div class="row">
        <div class="small-12 columns">
          <h5>Add Scripts your game is developed in</h5>
        </div>

        <div class="small-6 columns">Script</div>

        <div class="small-6 columns">
          <div v-for="(game, i) in gameObj.game_config_json.links" :key="i">
            <div class="row">
              <div class="small-6 columns">
                <input
                  v-model="gameObj.game_config_json.links[i]"
                  type="text"
                  style="width:100%"
                />
              </div>
              <div class="small-6 columns">
                <button class="button-red" @click="removeFramework(i)">
                  Delete Script
                </button>
              </div>
            </div>
          </div>
        </div>
        <div><button @click="addFramework">Add Framework</button></div>
        <br />
      </div>
    </div>
    <div class="row">
      <div class="small-12 columns">
        <button class="button-green" @click="addGameCrud">Add Game</button>
      </div>
    </div>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import SingleFileUpload from "@/components/shared/fileUpload/GameUpload"
import siteConfig from "@/utils/siteConfig"

export default {
  components: { SingleFileUpload, VueSelect },
  data() {
    return {
      selectedFramework: undefined,
      gameObj: {
        name: "",
        type: 5,
        time_allocated: 0,
        is_time_bound: false,
        game_script_file_id: "",
        game_config_json: {
          links: [],
        },
      },
      links: [],
      points: 0,
      selectedTags: [],
      tagOptions: [],
      tags: [],
      qtags: [],
    }
  },
  mounted() {
    this.populateTags()
  },
  methods: {
    removeFramework(i) {
      this.gameObj.game_config_json.links.splice(i, 1)
    },
    addFramework() {
      this.gameObj.game_config_json.links.push("")
    },
    catchFileUploadSuccess(event) {
      this.gameObj.game_script_file_id = event.id
    },
    populateTags() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}qtags/`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        const tags = res.data.data
        this.tagOptions = tags.map(item => ({ id: item.id, name: item.name }))
      })
    },
    getDeletedTags() {
      const deletedTags = []
      for (let i = 0; i < this.qtags.length; i++) {
        if (
          !this.findElementInArray(
            this.qtags[i].name,
            this.selectedTags.map(item => item.name)
          )
        ) {
          deletedTags.push(this.qtags[i])
        }
      }
      const finalTags = []
      for (let i = 0; i < deletedTags.length; i++) {
        finalTags.push(deletedTags[i].id)
      }
      return finalTags
    },
    getAddedTags() {
      const addedTags = []

      for (let i = 0; i < this.selectedTags.length; i++) {
        if (
          !this.findElementInArray(
            this.selectedTags[i].name,
            this.qtags.map(item => item.name)
          )
        ) {
          addedTags.push(this.selectedTags[i])
        }
      }
      const finalTags = []
      for (let i = 0; i < addedTags.length; i++) {
        finalTags.push(addedTags[i].id)
      }
      return finalTags
    },
    findElementInArray(element, array) {
      for (let i = 0; i < array.length; i++) {
        if (array[i] === element) {
          return true
        }
      }
      return false
    },
    addGameCrud() {
      this.gameObj.ops_qtags_unlink = this.getDeletedTags()
      this.gameObj.ops_qtags = this.getAddedTags()
      this.gameObj.game_config_json.framework = this.selectedFramework
      this.gameObj.points = this.points
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}questions/`,
        data: this.gameObj,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(() => {
        this.$router.push("/game/")
      })
    },
  },
}
</script>
